import React from 'react';
import { Grid, Row, Col, Text } from 'rsuite';
import {
  selectConfigExpressRegistrationVerbiage,
  selectConfigExpressSettingsName,
} from '../../../../store/slices/config/configSelectors';
import {
  selectPaymentSuccessInfo,
  selectSelectedPaymentMethod,
} from '../../../../store/slices/payment/paymentSelectors';
import { useSelector } from 'react-redux';
import { PAYMENT_METHODS } from '../../constants';
import PaymentCompletedCheck from './PaymentCompletedCheck';

const RenewSuccessFields = ({ isBulkRenew = false }) => {
  const selectedRegistrationVerbiage = useSelector(
    selectConfigExpressRegistrationVerbiage
  );
  const selectedPlaceName = useSelector(selectConfigExpressSettingsName);
  const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

  return (
    <Grid className="content-section">
      <Row>
        <Col xs={24}>
          <Grid
            fluid
            className="mb-24"
          >
            <Row>
              <Col xs={24}>
                <Grid fluid>
                  <Row>
                    <Col xs={24}>
                      <Text
                        className="mv-8"
                        as="div"
                      >
                        {paymentSuccessInfo && (
                          <>
                            {isBulkRenew
                              ? `Thank you! Your ${selectedRegistrationVerbiage} bulk renewal has been submitted successfully! `
                              : ` Thank you! Your ${selectedRegistrationVerbiage} ${paymentSuccessInfo?.id} Application has been submitted successfully! `}
                            {paymentSuccessInfo?.paymentConfirmation
                              ? ` Your confirmation number is: ${paymentSuccessInfo?.paymentConfirmation}.`
                              : ''}{' '}
                          </>
                        )}
                        <>
                          We have emailed you details of the application. Your
                          application will be reviewed and processed by{' '}
                          {selectedPlaceName}. We will contact you via email on
                          the status of your application.
                        </>
                      </Text>
                    </Col>
                  </Row>
                </Grid>
              </Col>
            </Row>
          </Grid>
          {paymentSuccessInfo &&
            selectedPaymentMethod === PAYMENT_METHODS.CHECK && (
              <PaymentCompletedCheck />
            )}
        </Col>
      </Row>
    </Grid>
  );
};

export default RenewSuccessFields;
